<template>
  <div
    v-if="killerQuestions && killerQuestions.length > 0"
    class="bg-card"
  >
    <strong>{{ $t('pages.publish-offer.second-page.killer-questions.short-title', 'Killer questions') }}</strong>
    <hr>
    <KillerAnswer
      v-for="(question, index) in killerQuestions"
      :key="question.id"
      ref="killerAnswer"
      :number="index + 1"
      :question="question"
      :candidate-answer-id="question.candidateAnswerId"
      :is-candidate-applied="isCandidateApplied"
      @updateAnswers="updateAnswers"
    />
    <div v-if="result !== null">
      <div class="row mb-3">
        <div class="col-2 labels">
          {{ $t('generic.result', 'Result') }}:
        </div>
        <div class="col-10">
          <div v-if="result < 1">
            {{ result }}%
          </div>
          <div v-else>
            <b-progress variant="success">
              <b-progress-bar
                :value="result"
                :label="`${result}%`"
              />
            </b-progress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KillerAnswer from "@/components/jobs/blocks/KillerAnswer.vue";

export default {
  components: {
    KillerAnswer
  },
  props: {
    offerId: {
      type: Number,
      default: 0
    },
    offerApplyId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      killerQuestions: null,
      killerAnswers: [],
      candidateAnswers: [],
      result: null
    }
  },
  computed: {
    isCandidateApplied() {
      return this.offerApplyId !== 0;
    }
  },
  mounted() {
    if (this.offerApplyId === 0) {
      this.getKillerQuestions();
    } else {
      this.questionsWithAnswers();
    }
  },
  methods: {
    getKillerQuestions() {
      this.axios.get('/offer/killerQuestionsCandidate/' + this.offerId)
        .then( response => {
          this.parseQuestions(response.data);
        })
        .catch();
    },
    parseQuestions(questions) {
      this.killerQuestions = [];
      for(let question of questions) {
        let oneQuestion = {
          id: question.id,
          question: question.text,
          candidateAnswerId: question.candidateAnswerId
        }

        for(let answer in question.killer_answers) {
          let number = Number(answer) + 1;
          oneQuestion['ans' + number] = {
            id: question.killer_answers[answer].id,
            text: question.killer_answers[answer].text,
            points: question.killer_answers[answer].points
          }
        }

        this.killerQuestions.push(oneQuestion);
      }
    },
    updateAnswers(data) {
      this.killerAnswers[data.number - 1] = data.answerId;
      this.$emit('updateKillerAnswers', this.killerAnswers);
    },
    questionsWithAnswers() {
      this.axios.get('/offer/killerQuestions/withAnswers/' + this.offerApplyId)
        .then( response => {
          this.result = response.data.result;
          delete response.data.result;
          let data = Object.values(response.data);
          this.parseQuestions(data);
        })
        .catch();
    },
    validateKillerAnswers() {
      let incorrectAnswers = 0;
      for(let index in this.killerQuestions) {
        if(!this.$refs.killerAnswer[index].validateAnswer()) {
          incorrectAnswers++;
        }
      }

      return incorrectAnswers === 0;
    }
  }
}
</script>
